import axios from '../services/axios';
import {HINTS_SERVER, HINTS_URL, RESTAURANT_ID, RESTAURANT_IDS} from '../config/api';
import {getValidToken, authHeader} from '../services/getValidToken';

const build_const = require('../config/build_const');

export async function savePrimaryAddress(deliveryDetails) {
  const token = await getValidToken();
  return axios.put(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/primaryaddress/`, deliveryDetails, authHeader(token));
}

export async function saveAddress(address) {
  const token = await getValidToken();
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/address`, address, authHeader(token));
}

export async function removeAddress(addressId) {
  const token = await getValidToken();
  return axios.delete(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/address/${addressId}`, authHeader(token));
}

export function getPlaceDetails(placeId) {
  return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${build_const.googleApiKey}`);
}

export function getBuildNumber(){
  const url = `${HINTS_URL}/HintsService/v1.0/rest/config/restaurant/${RESTAURANT_ID}/config/buildnumber`;
  return axios.get(url)
}


// WEBPACK FOOTER //
// ./src/actions/address.js